"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f234 = void 0;
exports.f234 = {
    "êeni": [
        2676
    ],
    "êđê": [
        6457
    ],
    "ê dê": [
        6457
    ],
    "ê": [
        6457
    ],
    "êpera": [
        6889
    ],
    "êpêra": [
        7385
    ]
};
